import styled from 'styled-components'
import { Section } from 'style'

export const StyledSection = styled(Section)`
  padding: 0 5vw 0 12.5vw;
`
